// Added for the Axeptio cookies banner
var current_cookie_lang = "hexagona/-base-fr";
if(document.documentElement.lang == 'en'){
  var current_cookie_lang = "hexagona/-base-en";
}
window.axeptioSettings = {
  clientId: "60c3872f738e6c446915c421",
  cookiesVersion: current_cookie_lang,
  googleConsentMode: {
    default: {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500
    }
  }
};

(function(d, s) {
  var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
  e.async = true; e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");


if(screen.width >= 1065) {
  document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll("li.menu-item-has-megamenu");

    menuItems.forEach(function(menuItem) {
      const promotionBannerImage = menuItem.querySelector(".mega-menu-promotion img");

      if (promotionBannerImage) {
        const originalImageUrl = promotionBannerImage.getAttribute("src");
        const originalSrcset = promotionBannerImage.getAttribute("data-srcset");
        menuItem.addEventListener("mouseover", function(event) {
          const target = event.target.closest("ul.mega-menu-columns a[data-image-url]");
          if (target) {
            const newImageUrl = target.getAttribute("data-image-url");
            const newSrcset = target.getAttribute("data-srcset");
            if (newImageUrl) {
              promotionBannerImage.setAttribute("src", newImageUrl);
              if (newSrcset) {
                promotionBannerImage.setAttribute("srcset", newSrcset);
              } else {
                promotionBannerImage.removeAttribute("srcset");
              }
            }
          }
        });

        menuItem.addEventListener("mouseout", function(event) {
          const target = event.target.closest("ul.mega-menu-columns a[data-image-url]");
          if (target) {
            promotionBannerImage.setAttribute("src", originalImageUrl);
            if (originalSrcset) {
              promotionBannerImage.setAttribute("srcset", originalSrcset);
            } else {
              promotionBannerImage.removeAttribute("srcset");
            }
          }
        });
      }
    });
  });
}
